//Преобразует  [anchor|https://example.com/] в ссылку
export const convertToLink = (text) => {
  if (!text) return text;

  const linkPattern = /\[([^\]|]+)\|((?:https?:\/\/|mailto:)[^\s\]]+)\]/g;

  return text.replace(linkPattern, (_m, linkText, linkUrl) => {
    const isHttp = /^https?:\/\//i.test(linkUrl);
    const safeText = linkText;

    // target/rel нужны только для http(s)
    const target = isHttp ? ' target="_blank"' : '';
    const rel = isHttp ? ' rel="noopener noreferrer"' : '';

    return `<a href="${linkUrl}"${target}${rel}>${safeText}</a>`;
  });
};
